module.exports = __webpack_public_path__ + "assets/img/banner-1.870ae6b8.png";